import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginGuardian implements CanActivate {

  constructor (private loginService: UsuarioService,
               private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (this.loginService.isAutenticado()){
        return true;
      } else {
        this.router.navigate(['']);
        return false;
      }
  }
}
